import { AxiosError } from 'axios'

import logger from '@/sdk/logger'
import { request } from '@/sdk/oauth'
import { PostcodeData } from '@/store/booking-funnel/postcode/types'

export function fetchPostcodeData(postcode: string): Promise<PostcodeData> {
  return request
    .get(`postcode/${postcode}`)
    .then(response => response.data)
    .catch((error: AxiosError) => {
      if (error.response.status !== 404) {
        logger.error('failed fetching postcode data', {
          error,
          tags: ['postcode', 'http'],
          additionalData: {
            postcode,
          },
        })
      }

      throw error
    })
}
